module.exports = __webpack_public_path__ + "img/1.2.5f6f57fc.svg";